<template>
  <nav class="panel" style="width: 100%">
    <p class="panel-heading filters-heading">
      <span class="clear-filters" @click="clearFilters">Clear</span>
    </p>
    <div class="panel-block">
      {{ filteredMarkers.length }} markers
    </div>
    <div class="panel-block">
      <div class="control">
        <label class="label">Types</label>
        <b-field v-for="type in types" :key="type">
          <b-checkbox v-model="typeCheckboxGroup" :native-value="type">
            {{ type }}
          </b-checkbox>
        </b-field>
      </div>
    </div>
    <!-- Sub-type Filters for Endusers -->
    <div v-if="showEnduserSubTypes" class="panel-block">
      <div class="control">
        <label class="label">KATR2</label>
        <div class="checkbox-group">
          <b-field v-for="etype in enduserTypes" :key="etype" class="is-block">
            <b-checkbox v-model="enduserTypeCheckboxGroup" :native-value="etype">
              {{ etype }}
            </b-checkbox>
          </b-field>
        </div>
      </div>
    </div>
    <div class="panel-block">
      <div class="control">
        <b-field label="Search">
          <b-autocomplete
            v-model="name"
            placeholder="enter name or id"
            :data="filteredMarkers"
            icon="search"
            field="name"
            @select="handleMarkerSelection"
          >
            <template slot="empty">
              No results found
            </template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>
    <!-- <div class="panel-block">
      <div class="control">
        <b-field label="Stock">
          <b-slider v-model="value" size="is-medium"/>
        </b-field>
      </div>
    </div> -->
  </nav>
</template>

<script>
export default {
  props: {
    markers: { type: Array, required: true }
  },
  data: function () {
    return {
      // value: 70,
      name: '',
      typeCheckboxGroup: [],
      enduserTypeCheckboxGroup: [],
      selectedMarker: null
    }
  },
  computed: {
    categories: function () {
      return [...new Set(this.markers.map(e => e.regionCategory).filter(e => e).sort())]
    },
    types: function () {
      return [...new Set(this.markers.map(e => e.mtype).filter(e => e).sort())]
    },
    enduserTypes: function () {
      const tmp = this.markers.filter(e => e.mtype === 'enduser').map(e => e.type).filter(e => e).sort()
      return [...new Set(tmp)]
    },
    // regions: function () {
    //   return [...new Set(this.markers.map(e => e.region).filter(e => e).sort())]
    // },
    showEnduserSubTypes () {
      return this.typeCheckboxGroup.includes('enduser')
    },
    filteredMarkers () {
      let { name, markers, typeCheckboxGroup,
        enduserTypeCheckboxGroup
      } = this

      markers = markers.filter(row => {
        const enduserSubTypeMatches = (row.mtype === 'enduser')
          ? enduserTypeCheckboxGroup.includes(row.type)
          : true // skip this filter for 'plant'
        const typeMatches = typeCheckboxGroup.includes(row.mtype)
        const nameMatches =
          name.length > 2
            ? row.name.toLowerCase().includes(name.toLowerCase()) ||
              row.enduserCode?.includes(name) ||
              row.id?.includes(name)
            : true

        return typeMatches &&
        nameMatches &&
        enduserSubTypeMatches
      })

      this.$emit('filter-changed', markers)

      return markers
    }
  },
  watch: {
    types: function (val) {
      this.typeCheckboxGroup = val
    },
    enduserTypes (val) {
      this.enduserTypeCheckboxGroup = val
    }
  },
  methods: {
    clearFilters () {
      this.name = ''
      this.typeCheckboxGroup = this.types
      this.enduserTypeCheckboxGroup = this.enduserTypes
    },
    handleMarkerSelection (marker) {
      this.selectedMarker = marker
      this.$emit('marker-selected', marker)// Notify parent to move map focus
    }
  }
}
</script>

<style>
.clear-filters {
  cursor: pointer;
}
.filters-heading {
  display: flex;
  justify-content: flex-end;
}

</style>
